import { Timestamp } from "firebase/firestore";
import { SearchHelper } from "../../utils/helpers";

export const bankAccountToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    const tenantName = typeof tenantData === 'string' ? '' : (tenantData?.tenantName || tenantData?.name || '');
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const cleanDescription = data.description?.trim() || "Nova Conta";

    const payload = {
        idTenant,
        tenantName,
        description: cleanDescription,
        searchName: SearchHelper.normalize(cleanDescription),
        bankName: data.bankName,
        accountType: data.accountType,
        agency: data.agency,
        accountNumber: data.accountNumber,
        initialBalance: Number(data.initialBalance),
        balance: data.id 
            ? (Number(data.balance) || 0)                  // Edição: mantém saldo atual
            : (Number(data.initialBalance) || 0),          // Criação: inicia com saldo inicial
        isDefault: !!data.isDefault,
        status: data.status,

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (data.id && data.createdBy) ? data.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Remove undefined
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados do Firestore para o React.
 */
export const bankAccountFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
